export const STATUS_METADATA = {
  matched: {
    label: "Matched",
    symbol: "✓",
    modifier: "matched",
    className: "status-matched"
  },
  unmatched: {
    label: "Unmatched",
    symbol: "○",
    modifier: "unmatched",
    className: "status-unmatched"
  },
  denied: {
    label: "Denied",
    symbol: "×",
    modifier: "denied",
    className: "status-denied"
  },
  need_update_confirmation: {
    label: "Needs update",
    symbol: "!",
    modifier: "update",
    className: "status-needs-update"
  },
  unavailable: {
    label: "Unavailable to you",
    symbol: "—",
    modifier: "unavailable",
    className: "status-unavailable"
  }
};

export const APPOINTMENT_STATUS_OPTIONS = [
  ["All statuses", "all"],
  ...["matched", "unmatched", "denied", "need_update_confirmation"].map((status) => [
    STATUS_METADATA[status].label,
    status
  ])
];

export const statusMetadata = (status) =>
  STATUS_METADATA[status] || {
    label: "Status unknown",
    symbol: "?",
    modifier: "unmatched",
    className: "status-unmatched"
  };
